// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"AuthPageContainer_container__1CTBL"};